export function addQuotes(text) {
  return `"${text}"`;
}

export default function deSlugify(text) {
  if (text) {
    return text.replace(/-/g, '');
  }
  return '';
}

export function capitalize(string) {
  return typeof string === 'string'
    ? `${string.charAt(0).toUpperCase()}${string.slice(1)}`
    : '';
}



// WEBPACK FOOTER //
// ./src/utils/string_util.js